var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvainlippu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 297.58 425.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#004086;}.cls-3,.cls-5{fill-rule:evenodd;}.cls-5{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-123.74 -122.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 544.25,
    height: 668.98
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avainlippu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M231,145.61V132.15l-25.42-9.9V437.57c-46.72,4.33-81.8,27.52-81.8,54.88,0,30.39,42.3,55,94.52,55s94.51-24.6,94.51-55c0-27.36-35.39-50.52-81.81-54.88V267.49H421.32V145.61Zm55.26,346.88c0,19-30.46,34.45-68,34.45s-68.05-15.41-68.05-34.45S180.62,458,218.19,458s68,15.42,68,34.47",
    transform: "translate(-123.74 -122.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.83,395.39c0-4.84-3.56-6.31-7.8-6.31H158v20.74h4.58v-8.3h2.27l4.32,8.3h5.49l-5.27-8.75c2.93-.53,4.46-2.79,4.46-5.68m-8.59,2.28h-2.68v-4.74h3c1.67,0,3.54.33,3.54,2.42,0,2.26-2.17,2.32-3.86,2.32",
    transform: "translate(-123.74 -122.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M165.67,379.41A20.37,20.37,0,1,0,186,399.78a20.37,20.37,0,0,0-20.34-20.37m0,36.72A16.35,16.35,0,1,1,182,399.78a16.38,16.38,0,0,1-16.32,16.35",
    transform: "translate(-123.74 -122.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231,191h51.76v-41.4H231Zm82.8,0H417.32v-41.4H313.76ZM231,263.49h51.76V222.06H231Zm82.8,0H417.32V222.06H313.76Z",
    transform: "translate(-123.74 -122.25)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvainlippu);
export default __webpack_public_path__ + "static/media/avainlippu.50c962fd3ef7926cb6d09ed6a987c890.svg";
export { ForwardRef as ReactComponent };